<template>
  <v-col id="home" class="pa-0">
    <Navbar/>
    <!-- HERO (FUNNEL START) -->
    <v-sheet class="hero" :style="heroStyle">
      <video
          v-if="homeHeroBackground && homeHeroBackgroundType === 'video'"
          class="hero-video"
          :src="homeHeroBackground"
          autoplay
          muted
          loop
          playsinline
          @error="clearHeroBackground"
      />
      <v-row class="hero-row ma-0">
        <v-col cols="12" md="7" lg="6" class="hero-content fade-in">
          <h1 class="mb-5 text-center">
            Dienstleister Live-Preisrechner
          </h1>
          <h3 class="text-center mb-5">Zutreffendes angeben • Unternehmen & Preise vergleichen • Auftrag Senden</h3>

          <v-text-field
              v-model="adresse"
              placeholder="Vollständige Adresse"
              autocomplete="off"
              clearable
              variant="solo"
              hide-details
              :loading="addressLoading"
              @update:modelValue="handleAddressInput"
              class="input-text-field"
          />
          <v-card
              v-if="hasSelectedAddress"
              class="address-result-card my-2 pa-3"
          >
            <span>
              <i
                  class="fa-solid fa-circle mr-5"
                  style="font-size: 12px;"
                  :style="{ color: availableFirmasCount > 0 ? '#00b400' : 'orange' }"
              />
              {{ availableFirmasText }}
            </span>
          </v-card>
          <v-card-text v-else class="address-help pa-1 text-center">
            Bitte geben Sie Ihre vollständige Adresse ein.
          </v-card-text>


          <v-card
              v-if="addressSuggestions.length"
              class="address-suggestions mb-3"
              elevation="8"
          >
            <v-list density="compact">
              <v-list-item
                  v-for="suggestion in addressSuggestions"
                  :key="suggestion.placeId"
                  @click="selectAddress(suggestion)"
              >
                <v-list-item-title>
                  <i class="fa-solid fa-location-dot mr-2"/>{{ suggestion.label }}
                </v-list-item-title>
              </v-list-item>
              <OsmAttribution/>
            </v-list>
          </v-card>

          <v-btn
              v-if="hasSelectedAddress"
              size="large"
              block
              color="primary"
              :disabled="!canStartFunnel"
              @click="startFunnel"
              class="mt-6"
          >
            Jetzt starten
          </v-btn>
        </v-col>
      </v-row>

    </v-sheet>

    <!-- TRUST SECTION -->
    <v-container class="home-section py-16 text-center fade-in">
      <h2>Warum {{ websiteName }}?</h2>

      <v-row class="mt-6 trustselection">
        <v-col cols="12" sm="4">
          <i class="fa-solid fa-bolt mr-2"/>
          <h3>Schnell</h3>
          <p>In wenigen Minuten zum Angebot</p>
        </v-col>

        <v-col cols="12" sm="4">
          <i class="fa-solid fa-coins mr-2"/>
          <h3>Kostenlos</h3>
          <p>Keine Gebühren für Kunden</p>
        </v-col>

        <v-col cols="12" sm="4">
          <i class="fa-solid fa-circle-check mr-2"/>
          <h3>Geprüfte Anbieter</h3>
          <p>Nur echte Unternehmen</p>
        </v-col>
      </v-row>
    </v-container>

    <!-- STEPS -->
    <v-container class="home-section py-16">
      <h2 class="text-center mb-8 fade-in">So funktioniert's</h2>

      <v-row>
        <v-col cols="12" sm="6" lg="4" v-for="(step, i) in steps" :key="i">
          <v-col class="pa-6 text-center step-card fade-up">
            <v-avatar size="50" color="primary" class="mb-3 text-shadow2 box-shadow">
              {{ i + 1 }}
            </v-avatar>
            <h3 class="mb-2">{{ step.title }}</h3>
            <p v-if="step.text">{{ step.text }}</p>
            <v-col
                v-for="beschreibung in step.text2"
                :key="beschreibung.id"
                class="d-flex align-center justify-center py-1"
            >
              <v-badge
                  color="primary"
                  :content="'5.' + beschreibung.number"
                  inline
                  class="mr-1 text-shadow2"
              />
              <p class="ma-0">
                {{ beschreibung.text }}
              </p>
            </v-col>

          </v-col>
        </v-col>
      </v-row>
    </v-container>

    <!-- BRANCHEN -->
    <v-container class="home-section py-16">
      <h2 class="text-center mb-6 fade-in">Beliebte Dienstleistungen</h2>

      <v-row v-if="loadingBranchen && !branchen.length">
        <v-col
            v-for="index in 4"
            :key="index"
            cols="12"
            sm="6"
            lg="4"
        >
          <v-skeleton-loader type="image, article"/>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col
            v-for="branch in branchen"
            :key="branch.id"
            cols="12"
            sm="6"
            lg="4"
        >
          <v-col class="branche-card pa-0">
            <v-card-text class="text-center text-shadow2 font-weight-bold card-titel pa-2">
              {{ branch.name }}
            </v-card-text>
            <v-row class="ma-0">
              <v-col cols="4" sm="5" class="card-img">
                <v-img
                    v-if="branch.bild"
                    :src="branch.bild"
                    contain
                />
              </v-col>
              <v-col cols="8" sm="7" class="branche-card__categories">

                <v-card-text
                    v-for="kategorie in branch.kategories"
                    :key="kategorie.id"
                    class="text-center py-1 px-0"
                >
                  <i class="fa-solid fa-check mr-2"/>{{ kategorie.name }}
                </v-card-text>
              </v-col>
            </v-row>

          </v-col>
        </v-col>
      </v-row>
    </v-container>

    <!-- FINAL CTA -->
    <v-container class="home-section text-center fade-in py-16 mb-16">
      <h2>Starte jetzt deinen Auftrag</h2>
      Transparent & ohne Gebühr<br>

      <v-btn
          size="large"
          color="primary"
          class="mt-3"
          @click="$router.push('/preisrechner')"
      >
        Auftrag starten
      </v-btn>
    </v-container>

    <!-- Unternehmen eintragen -->
    <v-container class="home-section py-0 mb-16">
      <v-card class="company-register-cta pa-6 text-center">
        <h2 class="mb-2">
          Du bist Unternehmer?
        </h2>
        <v-card-text class="pa-0 mb-4">
          Trage dein Unternehmen ein und werde für passende Kundenanfragen sichtbar.
        </v-card-text>
        <v-btn
            color="primary"
            size="large"
            @click="$router.push('/companyregister')"
        >
          <i class="fa-solid fa-plus mr-2"/>
          Unternehmen eintragen
        </v-btn>
      </v-card>
    </v-container>

    <AppFooter/>
    <!-- MODALS -->
    <ModalLogin ref="ModalLogin"/>
    <ModalAccount ref="ModalAccount"/>
  </v-col>
</template>

<script>
import {mapGetters} from "vuex";
import Navbar from '@/components/Navbar';
import ModalLogin from "@/components/modal/Login";
import ModalAccount from "@/components/modal/Account";
import {searchPhotonAddresses} from "@/services/photonAddress";
import OsmAttribution from "@/components/legal/OsmAttribution";
import AppFooter from "@/components/footer";
import {getHomeSettings} from "@/services/siteSettings";

export default {
  name: "HomeView",
  components: {
    AppFooter,
    Navbar,
    ModalLogin,
    ModalAccount,
    OsmAttribution
  },

  data() {
    return {
      adresse: "",
      selectedAddress: null,
      addressSuggestions: [],
      addressLoading: false,
      addressSearchTimeout: null,
      animationObserver: null,
      drivingDistances: {},
      drivingDistancesLoading: false,
      drivingDistancesReady: false,
      drivingDistancesRequestId: 0,
      homeHeroBackground: '',
      homeHeroBackgroundType: '',
      websiteName: 'MyService',
      steps: [
        {
          title: "Adresse eingeben",
          text: "Gib deine vollständige Adresse ein - wir zeigen dir verfügbare Branchen in deiner Nähe."
        },
        {
          title: "Branche wählen",
          text: "Wähle die passende Branche - z.B. Gebäudereinigung, Maler & Lackierer."
        },
        {
          title: "Kategorie/n wählen",
          text: "Präzisiere deine Anfrage mit der passenden Kategorie oder mehreren."
        },
        {
          title: "Leistung auswählen",
          text: "Wähle die einzelnen Leistungen und Elemente, die du benötigst."
        },
        {
          title: "Auftrag konfigurieren",
          text2: [
            {
              number: "1",
              text: "Art des Auftrags wählen"
            },
            {
              number: "2",
              text: "Unternehmensauswahl & Preisvergleich"
            },
            {
              number: "3",
              text: "Wunschtermin angeben"
            },
          ]
        },
        {
          title: "Senden",
          text: "Angaben prüfen & Auftrag kostenfrei senden. Der Anbieter meldet sich."
        }
      ]
    };
  },

  computed: {
    ...mapGetters(['user', 'firmas', 'branchen', 'loadingBranchen']),
    hasSelectedAddress() {
      return !!(
          this.selectedAddress &&
          this.selectedAddress.label === this.adresse &&
          this.selectedAddress.isComplete &&
          this.selectedAddress.lat &&
          this.selectedAddress.lon
      )
    },
    availableFirmas() {
      if (
          !this.hasSelectedAddress ||
          this.drivingDistancesLoading ||
          !this.drivingDistancesReady
      ) {
        return []
      }

      return (this.firmas || [])
          .filter(firma => firma?.serviceProfile?.gelistet === true)
          .filter(firma => this.isFirmaInServiceArea(firma))
    },
    availableFirmasCount() {
      return this.availableFirmas.length
    },
    availableFirmasText() {
      if (this.drivingDistancesLoading) {
        return 'Fahrstrecken werden berechnet'
      }

      if (this.availableFirmasCount === 0) {
        return 'Keine Unternehmen in Ihrer Region gefunden'
      }

      return this.availableFirmasCount === 1
          ? '1 Unternehmen gefunden'
          : `${this.availableFirmasCount} Unternehmen gefunden`
    },
    canStartFunnel() {
      return this.hasSelectedAddress && this.availableFirmasCount > 0
    },
    heroStyle() {
      if (!this.homeHeroBackground || this.homeHeroBackgroundType !== 'image') {
        return {}
      }

      return {
        backgroundImage: `url("${this.homeHeroBackground}")`
      }
    }
  },

  methods: {
    showModalLogin() {
      this.$refs.ModalLogin.setState(true);
    },
    showModalAccount() {
      this.$refs.ModalAccount.setState(true);
    },
    preloadImage(url) {
      return new Promise((resolve, reject) => {
        const image = new Image()

        image.onload = resolve
        image.onerror = reject
        image.src = url
      })
    },
    clearHeroBackground() {
      this.homeHeroBackground = ''
      this.homeHeroBackgroundType = ''
    },
    async loadHomeSettings() {
      try {
        const response = await getHomeSettings()
        const imageUrl = response.data?.settings?.homeHeroBackground || ''
        const mediaType = response.data?.settings?.homeHeroBackgroundType || ''
        this.websiteName = response.data?.settings?.websiteName || 'MyService'

        if (!imageUrl) {
          this.clearHeroBackground()
          return
        }

        if (mediaType === 'image') {
          await this.preloadImage(imageUrl)
        }

        this.homeHeroBackground = imageUrl
        this.homeHeroBackgroundType = mediaType
      } catch (error) {
        this.clearHeroBackground()
        this.websiteName = 'MyService'
      }
    },

    handleAddressInput(value) {
      this.selectedAddress = null;
      this.drivingDistances = {};
      this.drivingDistancesReady = false;
      clearTimeout(this.addressSearchTimeout);

      if (!value || value.trim().length < 3) {
        this.addressSuggestions = [];
        return;
      }

      this.addressSearchTimeout = setTimeout(() => {
        this.fetchAddressSuggestions(value);
      }, 350);
    },
    async fetchAddressSuggestions(value) {
      this.addressLoading = true;

      try {
        const results = await searchPhotonAddresses(value);

        this.addressSuggestions = results
            .filter(item => this.isCompleteAddress(item))
            .map((item) => ({
              placeId: item.place_id,
              label: this.formatAddress(item),
              plz: item.address?.postcode || "",
              lat: item.lat,
              lon: item.lon,
              isComplete: true
            }));
      } catch (error) {
        this.addressSuggestions = [];
      } finally {
        this.addressLoading = false;
      }
    },
    async selectAddress(suggestion) {
      this.selectedAddress = suggestion;
      this.adresse = suggestion.label;
      this.addressSuggestions = [];
      await this.loadDrivingDistances();
    },
    getPlzFromAddress(value) {
      return value?.match(/\b\d{5}\b/)?.[0] || "";
    },
    getAddressStreet(address) {
      return address?.road || address?.pedestrian || address?.footway || address?.residential || address?.path || "";
    },
    getAddressCity(address) {
      return address?.city || address?.town || address?.village || address?.municipality || "";
    },
    isCompleteAddress(item) {
      const address = item?.address || {};

      return !!(
          this.getAddressStreet(address) &&
          address.house_number &&
          this.getAddressCity(address) &&
          address.postcode &&
          item.lat &&
          item.lon
      );
    },
    formatAddress(item) {
      const address = item?.address || {};
      const streetWithHouse = `${this.getAddressStreet(address)} ${address.house_number}`.trim();

      return [
        streetWithHouse,
        [address.postcode, this.getAddressCity(address)].filter(Boolean).join(' '),
        address.country || "Deutschland"
      ].filter(Boolean).join(", ");
    },
    getFirmaId(firma) {
      return firma?.strapiId || firma?.id || null;
    },
    async loadDrivingDistances() {
      if (!this.hasSelectedAddress) {
        this.drivingDistances = {};
        this.drivingDistancesReady = false;
        return;
      }

      const requestId = ++this.drivingDistancesRequestId;
      const destinations = (this.firmas || [])
          .filter(firma => firma?.serviceProfile?.gelistet === true)
          .map(firma => ({
            id: this.getFirmaId(firma),
            lat: firma?.serviceProfile?.umkreis?.lat,
            lon: firma?.serviceProfile?.umkreis?.lon
          }))
          .filter(destination =>
              destination.id &&
              Number.isFinite(Number(destination.lat)) &&
              Number.isFinite(Number(destination.lon))
          );

      this.drivingDistancesLoading = true;
      this.drivingDistancesReady = false;

      try {
        const response = await fetch('/api/routing/distances', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            customerLat: this.selectedAddress.lat,
            customerLon: this.selectedAddress.lon,
            destinations
          })
        });
        const payload = await response.json();

        if (!response.ok || !payload.ok) {
          if (requestId === this.drivingDistancesRequestId) {
            this.drivingDistances = {};
            this.drivingDistancesReady = true;
          }
          return;
        }

        if (requestId !== this.drivingDistancesRequestId) {
          return;
        }

        this.drivingDistances = Object.fromEntries(
            (payload.distances || [])
                .filter(result =>
                    result.source === 'route' &&
                    result.distanceKm !== null &&
                    Number.isFinite(Number(result.distanceKm))
                )
                .map(result => [
                  String(result.id),
                  Number(result.distanceKm)
                ])
        );
        this.drivingDistancesReady = true;
      } catch (error) {
        if (requestId === this.drivingDistancesRequestId) {
          this.drivingDistances = {};
          this.drivingDistancesReady = true;
        }
      } finally {
        if (requestId === this.drivingDistancesRequestId) {
          this.drivingDistancesLoading = false;
        }
      }
    },
    isFirmaInServiceArea(firma) {
      const umkreis = firma?.serviceProfile?.umkreis;
      const kilometer = Number(umkreis?.kilometer || 0);
      const distance = Number(this.drivingDistances[String(this.getFirmaId(firma))]);

      if (!kilometer || !Number.isFinite(distance)) {
        return false;
      }

      return distance <= kilometer;
    },
    startFunnel() {
      if (!this.canStartFunnel) return;

      const address = this.selectedAddress;

      this.$router.push({
        path: '/preisrechner',
        query: {
          adresse: address.label || this.adresse,
          plz: address.plz || this.getPlzFromAddress(this.adresse),
          lat: address.lat || undefined,
          lon: address.lon || undefined
        }
      });
    },
    userAddressQuery() {
      if (!this.user?.street || !this.user?.house || !this.user?.zip || !this.user?.place) {
        return ''
      }

      return `${this.user.street} ${this.user.house}, ${this.user.zip} ${this.user.place}`
    },
    async preselectUserAddress() {
      if (!this.user) {
        this.adresse = ''
        this.selectedAddress = null
        this.addressSuggestions = []
        this.drivingDistances = {}
        this.drivingDistancesReady = false
        return
      }

      if (this.hasSelectedAddress) {
        return
      }

      const query = this.userAddressQuery()

      if (!query) {
        return
      }

      this.addressLoading = true

      try {
        const results = await searchPhotonAddresses(query, 1)
        const result = results.find(item => this.isCompleteAddress(item))

        if (!result) {
          return
        }

        await this.selectAddress({
          placeId: result.place_id,
          label: this.formatAddress(result),
          plz: result.address?.postcode || '',
          lat: result.lat,
          lon: result.lon,
          isComplete: true
        })
      } finally {
        this.addressLoading = false
      }
    },
    initAnimations() {
      this.animationObserver?.disconnect();

      const elements = document.querySelectorAll(
          ".fade-in:not(.visible), .fade-up:not(.visible)"
      );

      if (!('IntersectionObserver' in window)) {
        elements.forEach(element => element.classList.add('visible'));
        return;
      }

      this.animationObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            this.animationObserver.unobserve(entry.target);
          }
        });
      });

      elements.forEach(el => {
        this.animationObserver.observe(el);
      });
    }
  },

  watch: {
    firmas() {
      if (this.hasSelectedAddress) {
        this.loadDrivingDistances();
      }
    },
    branchen() {
      this.$nextTick(() => {
        this.initAnimations();
      });
    },
    user() {
      this.preselectUserAddress();
    }
  },

  mounted() {
    this.loadHomeSettings();

    if (!this.firmas?.length) {
      this.$store.dispatch('getFirmas');
    }

    if (!this.branchen?.length) {
      this.$store.dispatch('getBranchen');
    }

    this.$nextTick(() => {
      this.initAnimations();
    });

    this.preselectUserAddress();
  },

  beforeUnmount() {
    this.animationObserver?.disconnect();
  }

};
</script>
